import { PlusOutlined } from '@ant-design/icons';
import { useMount } from 'ahooks';
import { Divider, Input, Select } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CompanyAdminSelect = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  useMount(() => dispatch.org.getCompanies());
  const companies = useAppSelector((state) => state.org.companies);
  const onChange = (cid: number) => {
    dispatch.org.setState({ filterByCompanyId: cid });
  };
  const [name, setName] = useState('');
  const addCompany = () => {
    if (name.length === 0) return;
    dispatch.org.saveCompany(name);
    setName('');
  };

  const render = (menu: React.ReactElement) => {
    return (
      <div>
        {menu}
        <Divider style={{ margin: '4px 0' }} />
        <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
          <Input
            style={{ flex: 'auto' }}
            value={name}
            maxLength={255}
            onChange={(e) => setName(e.target.value)}
          />
          <a
            style={{
              flex: 'none',
              padding: '8px',
              display: 'block',
              cursor: 'pointer',
            }}
            onClick={addCompany}
          >
            <PlusOutlined />
          </a>
        </div>
      </div>
    );
  };
  return (
    <Select
      placeholder={t('platform.org.company.selectPlaceholder')}
      style={{ width: 200 }}
      allowClear
      onChange={onChange}
      dropdownRender={render}
      getPopupContainer={(e) => {
        return e as HTMLElement;
      }}
    >
      {companies.map((c) => (
        <Select.Option value={c.id} key={c.id}>
          {c.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default CompanyAdminSelect;
